import React from 'react'
import styled from 'react-emotion'
import { css } from 'emotion'
import { debounce } from 'lodash'

const Container = styled.div(props => `
  margin: 0;
  overflow: hidden;
  position: relative;
`)

const Hero = styled.div(props => `
  position: relative;
  height: 15rem;
  width: 100%;
  background-image: url(${props.mobileImg});
  background-size: cover;
  background-position: center;

  @media (min-width: 1024px) {
    height: 84vh;
  }
`)

const VideoClass = css`
  display: none;

  @media (min-width: 1024px) {
    display: block;
  }
`

let width = '1280'
let height = '720'

class HeroVideo extends React.Component {
  constructor(props) {
    super(props)
    this.element = null
    this.resizeVideo = debounce(() => this.sizeVideo(), 50)
  }
  componentDidMount() {
    window.addEventListener('resize', this.resizeVideo);
    // Set necessary styles to position video "center center"
    this.element.style['position'] = 'absolute'
    this.element.style['top'] ='50%'
    this.element.style['left'] ='50%'
    this.element.style['-webkit-transform'] = 'translate(-50%, -50%)'
    this.element.style['-ms-transform'] = 'translate(-50%, -50%)'
    this.element.style['transform'] = 'translate(-50%, -50%)'
  
    // Set overflow hidden on parent element
    this.element.parentElement.style['overflow'] = 'hidden'
    this.sizeVideo()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeVideo);
  }

  sizeVideo() {
    const parentHeight = this.element.parentElement.offsetHeight
    const parentWidth = this.element.parentElement.offsetWidth

    // Get native video height and width
    const nativeHeight = height
    const nativeWidth = width

    // Get the scale factors
    const heightScaleFactor = parentHeight / nativeHeight
    const widthScaleFactor = parentWidth / nativeWidth

    // Based on highest scale factor set width and height
    if (widthScaleFactor > heightScaleFactor) {
      this.element.style.height = 'auto'
      this.element.style.width = parentWidth + 'px'
    } else {
      this.element.style.height = parentHeight + 'px'
      this.element.style.width = 'auto'
    }
  }

  render() {
    return (
      <Container>
        <Hero mobileImg={this.props.mobileImg}>
          <video
            className={VideoClass}
            ref={(ref) => (this.element = ref)}
            muted
            loop
            width={width}
            height={height}
            autoPlay
            loading="lazy"
          >
            <source src={this.props.src} type='video/mp4' />
          </video>
        </Hero>
      </Container>
    );
  }
}
 
export default HeroVideo;


// WEBPACK FOOTER //
// ./src/components/HeroVideo.js